import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { NgClass } from '@angular/common';

export interface DrawerBottomBarButton {
  id: string;
  label: string;
  color: 'primary' | 'accent' | 'warn' | '';
  action: string | (() => void);
  enabled?: boolean;
  visible?: boolean;
  permissions?: string[];
  icon?: string;
}

@Component({
  selector: 'sbd-doug-frontend-common-drawer-footer',
  standalone: true,
  imports: [
    CommonModule,
    MatButton,
    MatIcon,
    NgClass,
  ],
  templateUrl: './common-drawer-footer.component.html',
  styles: [`
    :host {
      display: block;
      flex-shrink: 0;
    }

    .common-drawer-footer {
      box-sizing: border-box;
      padding: 1rem;
      padding-bottom: calc(1rem + env(safe-area-inset-bottom, 0px));
    }
  `],
})
export class CommonDrawerFooterComponent {
  @Input() buttons: DrawerBottomBarButton[] = [];
  @Input() buttonPosition: 'start' | 'end' | 'between' | 'center' = 'between';
  @Input() componentRef: object | null = null;

  @Output() buttonClick = new EventEmitter<DrawerBottomBarButton>();

  get visibleButtons(): DrawerBottomBarButton[] {
    return this.buttons.filter(button => button.visible !== false);
  }

  onButtonClick(button: DrawerBottomBarButton): void {
    if (!button.enabled) {
      return;
    }

    this.buttonClick.emit(button);

    if (typeof button.action === 'function') {
      button.action();
    } else if (typeof button.action === 'string' && this.componentRef) {
      this.handleStringAction(button.action);
    }
  }

  private handleStringAction(action: string): void {
    const actionHost = this.componentRef as Record<string, unknown> | null;
    const actionHandler = actionHost?.[action];

    if (typeof actionHandler === 'function') {
      actionHandler.call(this.componentRef);
    } else {
      console.warn(`Action method '${action}' not found on component reference`);
    }
  }

  getButtonClasses(button: DrawerBottomBarButton): string {
    const baseClasses = 'ml-2';
    const colorClasses = button.color === 'primary' ? 'mat-flat-button-primary' : '';
    return `${baseClasses} ${colorClasses}`.trim();
  }
}
